import apiClient from "../config/apiClient";


export const fetchLabRequests = async (id) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.post(`/public/portal?url=requests/${id}/request/portal/labs?page=1%26limit=10%26startDate=%26endDate=%26item_id=%26type=`, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
